<span class="filter-select__label" [id]="labelId">{{ label }}</span>
<ngf-autocomplete
  class="filter-select__control"
  [placeholder]="placeholder"
  [selected]="value"
  [ariaLabelledby]="labelId"
  [enableOptionsAnnouncement]="true"
  (search)="query = $event"
  (selectedChange)="onSelect($event)">
  <ngf-options-container class="filter-select__panel">
    @for (option of shownOptions; track option) {
      <ngf-option [value]="option">{{ option }}</ngf-option>
    } @empty {
      <ngf-opt-hint>No matches</ngf-opt-hint>
    }
  </ngf-options-container>
</ngf-autocomplete>
